module.exports = __webpack_public_path__ + "static/media/thigh-quizz.0c46be52.jpg";